import Constants from '../utils/Constants';

export const membersValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('auctions.bids-list.place-bid.validation.members-empty');
    }
    return err;
};

const ALLOWED_ASCII_CHARS = /[\x20-\x7F]+$/;

export const MEMBER_ID_LENGTH = 5;
export const memberIdValidator = (t) => (input) => {
    let err = null;
    const inputLength = input.trim().length;
    if (inputLength < MEMBER_ID_LENGTH || inputLength > MEMBER_ID_LENGTH) {
        err = t('members.validation.member-id-wrong-length', { memberIdLength: MEMBER_ID_LENGTH });
    } else if (input.match(ALLOWED_ASCII_CHARS) === null) {
        err = t('members.validation.member-id-wrong-chars');
    }
    return err;
};

export const MEMBER_NAME_MAX_LENGTH = 64;
export const memberNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('members.validation.member-name-empty');
    } else if (input.length > MEMBER_NAME_MAX_LENGTH) {
        err = t('members.validation.member-name-too-long', { maxLetters: MEMBER_NAME_MAX_LENGTH });
    }
    return err;
};

export const BALANCING_GROUP_LENGTH = 16;
export const memberBalancingGroupValidator = (t, isMandatory = true) => (input) => {
    let err = null;
    const existsInputForValidation = input.trim().length !== 0;
    if (existsInputForValidation || isMandatory) {
        const inputLength = input.length;
        if (inputLength < BALANCING_GROUP_LENGTH || inputLength > BALANCING_GROUP_LENGTH) {
            err = t('members.validation.member-balancing-group-wrong-length', { balancingGroupLength: BALANCING_GROUP_LENGTH });
        } else if (input.match('^[0-9]{2}[A-Z][0-9A-Z-]{12}[0-9A-Z]$') === null) {
            err = t('members.validation.member-balancing-group-wrong-chars');
        }
    }
    return err;
};

export const MEMBER_EMAILS_MAX_LENGTH = 64;
export const memberEmailsValidator = (t) => (input) => {
    let err = null;
    if (input.length > MEMBER_EMAILS_MAX_LENGTH) {
        err = t('members.validation.member-emails-too-long', { maxLetters: MEMBER_EMAILS_MAX_LENGTH });
    } else if (input.length !== 0 && !Constants.EMAILS_REGEX.test(input)) {
        err = t('members.validation.member-emails-invalid-format');
    }
    return err;
};

export const MEMBER_PHONE_MAX_LENGTH = 64;
export const memberPhoneValidator = (t) => (input) => {
    let err = null;
    if (input.length > MEMBER_PHONE_MAX_LENGTH) {
        err = t('members.validation.member-phone-too-long', { maxLetters: MEMBER_PHONE_MAX_LENGTH });
    } else if (input.match('^[0-9-/; ()+]*$') === null) {
        err = t('members.validation.member-phone-invalid-format', { allowedChars: '0-9-/; ()+' });
    }
    return err;
};
